module.exports = __webpack_public_path__ + "static/img/100229.56d8f517.png";